import { Api, JsonRpc } from 'eosjs';
import {JsSignatureProvider} from 'eosjs/dist/eosjs-jssig'

// Main action call to blockchain
async function takeAction(action, dataValue) {
  const privateKey = localStorage.getItem("cardgame_key");
  const rpc = new JsonRpc(process.env.REACT_APP_EOS_HTTP_ENDPOINT);
  const signatureProvider = new JsSignatureProvider([privateKey]);
  const api = new Api({ rpc, signatureProvider, textDecoder: new TextDecoder(), textEncoder: new TextEncoder() });

  // Main call to blockchain after setting action, account_name and data
  try {
    const resultWithConfig = await api.transact({
      actions: [{
        account: process.env.REACT_APP_EOS_CONTRACT_NAME,
        name: action,
        authorization: [{
          actor: localStorage.getItem("cardgame_account"),
          permission: 'active',
        }],
        data: dataValue,
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
    return resultWithConfig;
  } catch (err) {
    throw(err)
  }
}


async function takeAction2(quantity1,memo1) {
  const privateKey = localStorage.getItem("cardgame_key");
  const rpc = new JsonRpc(process.env.REACT_APP_EOS_HTTP_ENDPOINT);
  const signatureProvider = new JsSignatureProvider([privateKey]);
  const api = new Api({ rpc, signatureProvider, textDecoder: new TextDecoder(), textEncoder: new TextEncoder() });

  // Main call to blockchain after setting action, account_name and data
  try {
    const resultWithConfig = await api.transact({
      actions: [{
        account: "eosio.token",
        name: "transfer",
        authorization: [{
          actor: localStorage.getItem("cardgame_account"),
          permission: 'active',
        }],
        data:  {
          from: localStorage.getItem("cardgame_account"),
          to: process.env.REACT_APP_EOS_CONTRACT_NAME,
          quantity: quantity1,
          memo: memo1
        }
      }]
    }, {
      blocksBehind: 3,
      expireSeconds: 30,
    });
    return resultWithConfig;
  } catch (err) {
    throw(err)
  }
}



class ApiService {

  static login({ username, key }) {
    return new Promise((resolve, reject) => {
      localStorage.setItem("cardgame_account", username);
      localStorage.setItem("cardgame_key", key);
      takeAction("login", { username: username })
        .then(() => {
          console.log("login success")
          resolve();
          
        })
        .catch(err => {
          localStorage.removeItem("cardgame_account");
          localStorage.removeItem("cardgame_key");
          reject(err);
        });
    });
  }

  static logOut(){
    localStorage.removeItem("cardgame_account");
    localStorage.removeItem("cardgame_key");
    localStorage.clear();
    window.location.href = '/';
  }

  static async getUserByName() {
    try {
      const rpc = new JsonRpc(process.env.REACT_APP_EOS_HTTP_ENDPOINT);
      const result = await rpc.get_table_rows({
        "json": true,
        "code": process.env.REACT_APP_EOS_CONTRACT_NAME,    // contract who owns the table
        "scope": process.env.REACT_APP_EOS_CONTRACT_NAME,   // scope of the table
        "table": "items",    // name of the table as specified by the contract abi
        "limit": 35
      });
     // console.log(result.rows)
      return result.rows;

    } catch (err) {
      console.error(err);
    }
  }
  





  static upsert(dataToSend,total){
    var data=[]
    var loop=1
    data[0]=dataToSend.length
     dataToSend.map(item=>{
      

      data[loop]=item.key
        loop++
        data[loop]=item.quantity
        loop++
    })
    const name= localStorage.getItem("cardgame_account")
    if(!name)
    {
      alert("Please Login First")

    }
else
{
    function addZeroes( num ) {
      var value = Number(num);
      var res = num.split(".");
      if(res.length === 1 || (res[1].length < 5)) {
          value = value.toFixed(4);
      }
      value=value+" EOS"
      return value
  }

   var net_price=""
   net_price=addZeroes(total.toString())
    
    var myStr =data.toString()
   
    var memo = myStr.replace(/,/g, ':');
    memo=memo+":"
    
    takeAction2(net_price,memo)
    .then(() =>{
          alert("Intiated order sucessfully");
          window.location.href = '/';
         
        })
        .catch(err => {
         console.log(err);
         alert("Error:" +err)
        });
    
}

  }
  
}

export default ApiService;
